import { Pipe, PipeTransform } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import dayjs from "dayjs";
import { dateUtil } from "src/app/support/date-util";
import { Nullable } from "src/app/support/nullable";
import { sntTranslate } from "src/app/support/translate";

@Pipe({
  name: "age",
  standalone: false
})
export class AgePipe implements PipeTransform {
  transform(startDate: Nullable<string | number>, endDate?: string): string {
    let ageLabel: string = "";

    if (!!startDate) {
      const label = {
        day: sntTranslate(marker("giorno")),
        days: sntTranslate(marker("giorni")),
        month: sntTranslate(marker("mese")),
        months: sntTranslate(marker("mesi")),
        year: sntTranslate(marker("anno")),
        years: sntTranslate(marker("anni")),
        and: sntTranslate(marker("e"))
      };

      const endDateDayJs = endDate ? dateUtil(endDate) : dateUtil();

      const ageDiff = dayjs.duration(
        endDateDayJs.diff(dateUtil(startDate)),
        "milliseconds"
      );

      const years = ageDiff.years();

      if (years > 0) {
        ageLabel = `${years} ${years === 1 ? label.year : label.years}`;

        const yMonths = ageDiff.months() % 12;

        if (yMonths > 0) {
          ageLabel = `${ageLabel} ${label.and} ${yMonths} ${yMonths === 1 ? label.month : label.months}`;
        }
      } else {
        const months = ageDiff.months();

        if (months > 0) {
          ageLabel = `${months} ${months === 1 ? label.month : label.months}`;

          const yDays = ageDiff.days() % 30;

          if (yDays > 0) {
            ageLabel = `${ageLabel} ${label.and} ${yDays} ${yDays === 1 ? label.day : label.days}`;
          }
        }

        const days = ageDiff.days();

        if (months === 0 && days > 0) {
          ageLabel = `${days} ${days === 1 ? label.day : label.days}`;
        }
      }
    }

    return ageLabel;
  }
}
